import React, { useState } from 'react';
import useDidMountEffect from "../customHooks/useDidMountEffect";
import DeliveryChoice from '../payment/DeliveryChoice';
import PaymentSummary from "./PaymentSummary";
import apiCall from "../apiCall";
import PaymentForm from "../payment/PaymentForm";
import { CSSTransition } from 'react-transition-group';
import popupService from '../popup-service';
import PaymentSucceeded from '../payment/PaymentSucceeded';
import PropTypes from "prop-types";
import usePaymentRequest from "../customHooks/usePaymentRequest";
import BrowserCardPaymentForm from "../payment/BrowserCardPaymentForm";

const PaymentPage = (
    {
        paymentData
    }
) => {

    const [deliveryChosen, setDeliveryChosen] = useState(paymentData.deliveryChosen ?? false);
    const [changeDeliveryRequestCount, setChangeDeliveryRequestCount] = useState(0);

    const [totalToPayAsBritishCurrency, setTotalToPayAsBritishCurrency] = useState(paymentData.totalToPayAsBritishCurrency);
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);
    const [showPaymentSucceeded, setShowPaymentSucceeded] = useState(false);


    const showDelivery = paymentData.includeDelivery && !paymentSucceeded;

    const onDeliveryChoiceMade = wantDelivery => {
        setDeliveryChosen(wantDelivery);
        setChangeDeliveryRequestCount(changeDeliveryRequestCount + 1);
    };

    const onPaymentSucceeded = () => {
        setPaymentSucceeded(true);
        setTimeout(() => setShowPaymentSucceeded(true), 1000);
    };

    const onPaymentFailed = (errorMessage) => {
        popupService.renderErrorMessage(errorMessage);
    };

    const {
        paymentRequestId,
        setNewPaymentRequest,
        paymentRequest
    } = usePaymentRequest(paymentData.clientSecret,
        deliveryChosen,
        paymentData.totalToPay,
        `${paymentData.auctionName} total`,
        onPaymentSucceeded, onPaymentFailed);



    useDidMountEffect(() => {
        const onSuccess = async data => {
            setTotalToPayAsBritishCurrency(data.totalToPayAsBritishCurrency);
            setNewPaymentRequest(data.totalToPay, deliveryChosen, true);
        };

        const onFail = e => {
            apiCall.defaultFail(e);
            setDeliveryChosen(!deliveryChosen);
        };

        const postData = {
            id: paymentData.id,
            contactId: paymentData.contactId,
            deliveryRequired: deliveryChosen
        };
        apiCall.post("/api/payment/wantBuyItNowDelivery", postData, onSuccess, onFail);

    }, [changeDeliveryRequestCount]);


    const paymentSucceededProps = {
        isAdmin: paymentData.isAdmin ?? false,
        todaysDate: paymentData.todaysDate,
        totalToPay: totalToPayAsBritishCurrency,
        auctionId: paymentData.auctionId
    }

    const deliverChoiceProps = {
        deliveryChosen,
        onDeliveryChoiceMade: onDeliveryChoiceMade,
    }

    const summaryProps = {
        itemTotal: paymentData.itemTotal,
        deliveryChosen,
        deliveryCharge: paymentData.deliveryCharge,
        totalToPayAsBritishCurrency,
        itemTitle: paymentData.itemTitle,
    }

    const cssTransitionProps = {
        in: showPaymentSucceeded,
        timeout: 400,
        classNames: "fade",
    }

    const browserCardPaymentFormProps = {
        key: paymentRequestId,
        paymentSucceeded: paymentSucceeded,
        paymentRequest: paymentRequest,
    }

    const paymentFormProps = {
        publishableKey: paymentData.publishableKey,
        clientSecret: paymentData.clientSecret,
        showError: onPaymentFailed,
        onSuccess: onPaymentSucceeded,
        customerName: paymentData.customerName,
        deliveryChosen,
        paymentSucceeded: paymentSucceeded,
    }

    return (
        <>
            {
                showDelivery &&
                <DeliveryChoice {...deliverChoiceProps} />
            }
            <PaymentSummary {...summaryProps} />
            <CSSTransition {...cssTransitionProps} mountOnEnter >
                <PaymentSucceeded {...paymentSucceededProps} />
            </CSSTransition>
            {
                paymentRequest &&
                <BrowserCardPaymentForm {...browserCardPaymentFormProps} />
            }
            <PaymentForm {...paymentFormProps} />

        </>

    );
};


PaymentPage.propTypes = {
    paymentData: PropTypes.object.isRequired
}

export default PaymentPage;
